import {Component, inject, ViewChild, Input, ElementRef, OnDestroy, Output, EventEmitter} from '@angular/core';
import {finalize, takeUntil} from "rxjs/operators";
import {Photos} from "../../interfaces/account-goods-data";
import {Clipboard} from "@angular/cdk/clipboard";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {BaseService} from "../../services/base.service";
import {LocalStorageService} from "../../services/local-storage.service";
import {Favorites, FavoritesData} from "../../interfaces/favorites-data";
import {Organization} from "../../interfaces/organization";
import {
  ModalGoodAddToBasketMobileComponent
} from "../../pages/good/modal-good-add-to-basket-mobile/modal-good-add-to-basket-mobile.component";
import {
  ModalNonReturnableItemsComponent
} from "../../pages/account/modal-non-returnable-items/modal-non-returnable-items.component";
import {ModalGoodInformationComponent} from "../../pages/good/modal-good-information/modal-good-information.component";
import {GoodsService} from "../../services/goods.service";
import {RequestData} from "../../interfaces/request-data";

@Component({
  selector: 'app-goods-list',
  templateUrl: './goods-list.component.html',
  styleUrls: ['./goods-list.component.scss', '../../pages/account/account.component.scss', '../../pages/good/good.component.scss']
})
export class GoodsListComponent extends BaseService implements OnDestroy {
  @ViewChild('scrollableRef') scrollableRef: ElementRef;
  @ViewChild(ModalGoodAddToBasketMobileComponent) modalGoodAddToBasketMobileComponentRef: ModalGoodAddToBasketMobileComponent;
  @ViewChild(ModalNonReturnableItemsComponent) modalNonReturnableItemsComponentRef: ModalNonReturnableItemsComponent;
  @ViewChild(ModalGoodInformationComponent) modalGoodInformationComponentRef: ModalGoodInformationComponent;

  @Input() goods = [];
  @Input() currencyName: string;
  @Input() isAdmin: boolean;
  @Input() roleId: number;
  @Input() userSupper: number;
  @Input() partnersNotShowReturnMessage: boolean;
  @Input() activeOrganization: Organization;
  // Кошик сторінки товару: перечитує його сама сторінка (getBasketAnalogsEvent), власного запиту список не робить
  @Input() basketData = [];

  @Output() showModalWaitDeliveryEvent = new EventEmitter<boolean>();
  @Output() getBasketAnalogsEvent = new EventEmitter<boolean>();
  @Output() buildAnalogsFavoritesBasket = new EventEmitter();

  private clipboard = inject(Clipboard);
  private http = inject(HttpClient);
  private localStorage = inject(LocalStorageService);
  private goodsService = inject(GoodsService);

  public isDestroyed: Subject<boolean> = new Subject();

  public isDarkBackground = false;
  public isArticlesShow = false;
  public isArticleHide = false;
  public goodName = '';
  public goodPhotos: Photos[];
  public isOpenModalPhoto = false;
  public isCopyTextShow = false;
  public copyText;
  public basketModalData: {
    index: number,
    name: string,
    pack_id: number,
    warehouse: number,
    count: number,
    gid: string,
    sup_wh_id?: number
  } = {
    index: 0,
    name: '',
    pack_id: 0,
    warehouse: 0,
    count: 1,
    gid: null,
    sup_wh_id: null
  };
  public isGetGoods = false;
  public favorites: Favorites[] = [];
  public favoritesModalData: {
    name: string,
    pack_id: any,
    count: number
  } = {
    name: '',
    pack_id: 0,
    count: 1
  };

  private pendingBasket: { id: number, count: number, sup: any, gid: string };
  // Позиції, які зараз кладемо в кошик (захист від подвійного кліку, #515)
  private addingToBasket: {[key: string]: boolean} = {};
  // Товари, які зараз додаємо в обране: сердечко світиться лише після get_favorites, і подвійний
  // клік слав add_to_favorite двічі - бек додає кількість до наявної, в обраному ставало 2
  private addingToFavorite: {[key: string]: boolean} = {};
  private pendingBasketMobile: { id: number, sup: any, name: string, gid: string };
  public isMobileAgreement = false;
  public isFavoriteMessageShow = false;
  private favoriteMessageTimer;
  public favoriteMessage = '';

  openGoodInfoModal(good_id) {
    this.modalGoodInformationComponentRef.openModalGoodInformation(good_id);
  }

  openModalPhotos(good) {
    this.goodName = good.name
    this.goodPhotos = good.photos

    this.isOpenModalPhoto = true;
    this.isDarkBackground = true;
  }

  articlesShow() {
    this.isArticlesShow = true;
  }

  articleCopy(firstArticle) {
    this.clipboard.copy(firstArticle);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  packIdCopy(packId: string) {
    this.clipboard.copy(packId);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  articleBulbCopy(lastArticles, event) {
    event.stopPropagation();
    this.clipboard.copy(lastArticles);

    this.isCopyTextShow = true;
    this.isArticleHide = true;

    clearTimeout(this.copyText);
    setTimeout(() => {
      this.isArticleHide = false;
    }, 20);

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000);
  }

  notifyInventoryFinished(package_id) {
    this.http.post(this.apiRoot + 'accounts/subscribe_goods_appeared', {
      package_id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        alert('Телеграм бот повідомить вас про закінчення інвентаризації цього товару. Якщо ви підписані на бот.');
      });
  }

  showModalWaitDelivery() {
    this.showModalWaitDeliveryEvent.emit();
  }

  minusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) - 1

    if (sup.countBasket < 1) {
      sup.countBasket = 1;
    }
  }

  plusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) + 1

    if (isNaN(sup.countBasket)) {
      sup.countBasket = 1;
    }
  }

  addToBasketMobile(id, sup, name) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasketMobile = { id, sup, name, gid };

      this.isMobileAgreement = true;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.basketMobileModalShow(id, sup, name);
    }
  }

  basketMobileModalShow(id, sup, name) {
    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    this.basketModalData.name = name;
    this.basketModalData.pack_id = id;
    this.basketModalData.warehouse = sup.war;
    this.basketModalData.count = 1;
    this.basketModalData.gid = sup.gid || null;
    this.basketModalData.sup_wh_id = sup.sup_wh_id || null;

    this.modalGoodAddToBasketMobileComponentRef.modalShow();

    this.isDarkBackground = true;
  }

  isDarkBackgroundAddGoodToBasketModal() {
    this.isDarkBackground = false;
  }


  addToBasket(id, count, sup) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasket = {id, count, sup, gid};

      this.isMobileAgreement = false;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.sendAddToBasket(id, count, sup, gid);
    }
  }

  sendAddToBasket(id, count, sup, gid = null) {

    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    // Подвійний клік «В кошик» клав позицію двічі (#515; у мобільній модалці захист є з #305).
    // Поки запит по цій позиції йде і ще пів секунди від кліку, повтор ігноруємо.
    const addKey = id + '_' + sup.war + '_' + (sup.sup_wh_id || '');

    if (this.addingToBasket[addKey]) {
      return;
    }

    this.addingToBasket[addKey] = true;
    const addStartedAt = Date.now();

    const payload: any = {
      package_id: id,
      count: count,
      warehouse: sup.war,
      delivery: this.localStorage.get('delivery_id'),
      gid: gid
    };

    // Склад партнёра (контракт п.3 с бэком): пока бэк поле не читает — кладёт как раньше, без склада
    if (sup.sup_wh_id) {
      payload.sup_wh_id = sup.sup_wh_id;
    }

    this.http.post(this.apiRoot + 'basket_data/add_basket', payload)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToBasket[addKey], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe((data: RequestData) => {
        this.goodsService.notifyAddBasketError(data);

        this.isGetGoods = true;

        // Кошик перечитує сторінка товару (як і з мобільної модалки) - власний get_basket тут був
        // другим однаковим запитом
        this.getBasketAnalogsEvent.emit();

        this.buildFavoritesBasket();
      })
  }

  agreeAddToBasket() {
    if (!this.isMobileAgreement && this.pendingBasket) {
      const { id, count, sup, gid } = this.pendingBasket;
      this.sendAddToBasket(id, count, sup, gid);
    } else if (this.isMobileAgreement && this.pendingBasketMobile) {
      const { id, sup, name} = this.pendingBasketMobile;
      this.basketMobileModalShow(id, sup, name);
    }
  }

  agreeNotShowMore() {
    this.http.post(this.apiRoot + 'basket_data/partners_not_show_return_message', {})
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.agreeAddToBasket();
      });
  }

  getBasketMobile() {
    this.getBasketAnalogsEvent.emit()
  }

  buildFavoritesBasket() {
    if (this.isGetGoods) {
      this.isGetGoods = false;

      for (let analog of this.goods) {
        for (let sup of analog.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == analog.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == analog.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == analog.id)) : false;
        }
      }
    }
  }

  toggleFavorite(name, id, isFavorite: boolean) {
    if (isFavorite) {
      this.http.post(this.apiRoot + 'favorites/delete', {
        package_id: id
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe(() => {
          this.isGetGoods = true;
          this.getFavorites();
          this.showFavoriteMessage('Продукт видалено із списку побажань');
        });

      return;
    }

    if (this.addingToFavorite[id]) {
      return;
    }

    this.addingToFavorite[id] = true;
    const addStartedAt = Date.now();

    this.favoritesModalData.name = name;
    this.favoritesModalData.pack_id = id;

    this.http.post(this.apiRoot + 'favorites/add_to_favorite', {
      package_id: this.favoritesModalData.pack_id,
      count: this.favoritesModalData.count
    })
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToFavorite[id], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe(() => {
        this.favoritesModalData.count = 1;
        this.isGetGoods = true;
        this.getFavorites();
        this.showFavoriteMessage('Додано в обране.');
      })
  }

  showFavoriteMessage(message: string) {
    this.favoriteMessage = message;
    this.isFavoriteMessageShow = true;

    clearTimeout(this.favoriteMessageTimer);

    this.favoriteMessageTimer = setTimeout(() => {
      this.isFavoriteMessageShow = false;
    }, 2500);
  }

  getFavorites() {
    this.http.get(this.apiRoot + 'accounts/get_favorites')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: FavoritesData) => {
        if (data && Array.isArray(data.data)) {
          this.favorites = data.data;
        } else {
          this.favorites = [];
        }

        this.buildAnalogsFavoritesBasket.emit();
        this.buildFavoritesBasket();
      });
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
